import { useNavigate } from 'react-router-dom';

export function MasterHomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      {/* Header */}
      <div className="mb-12 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Tabillo</h1>
        <p className="text-gray-500 text-sm">master.tabillo.com</p>
      </div>

      {/* App tiles */}
      <div className="flex gap-6 flex-wrap justify-center">
        {/* Roadmap Planner tile */}
        <button
          onClick={() => navigate('/login')}
          className="group w-64 bg-white border border-gray-200 rounded-xl p-8 text-left shadow-sm hover:shadow-md hover:border-blue-300 transition-all"
        >
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-5 group-hover:bg-blue-200 transition-colors">
            <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-900 mb-1">Roadmap Planner</h2>
          <p className="text-sm text-gray-500 leading-snug">
            Plan and track product initiatives across your organization.
          </p>
        </button>

        {/* Admin tile */}
        <button
          onClick={() => navigate('/admin')}
          className="group w-64 bg-white border border-gray-200 rounded-xl p-8 text-left shadow-sm hover:shadow-md hover:border-indigo-300 transition-all"
        >
          <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-5 group-hover:bg-indigo-200 transition-colors">
            <svg className="w-6 h-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-900 mb-1">Admin</h2>
          <p className="text-sm text-gray-500 leading-snug">
            View and manage all tenant organizations and platform usage.
          </p>
        </button>
      </div>
    </div>
  );
}
